const NO_SUB = 'px-2 py-3 sm:px-3 sm:py-2';
const WITH_SUB = 'whitespace-pre-wrap px-2 py-3 sm:px-3 sm:py-2';

export const addressServices = [
    {
        id: 'rakuten_card',
        logo: '/assets/service-logos/card.png',
        name: '楽天カード',
        link: 'https://r10.to/hfgIbE',
        className: NO_SUB,
    },
    {
        id: 'rakuten_bank',
        logo: '/assets/service-logos/bank.png',
        name: '楽天銀行',
        link: 'https://www.rakuten-bank.co.jp/guide/register/change-name.html?scid=wi_ich_change_201802',
        className: NO_SUB,
    },
    {
        id: 'rakuten_securities',
        logo: '/assets/service-logos/securities.png',
        name: '楽天証券',
        link: 'https://www.rakuten-sec.co.jp/ITS/V_ACT_Login.html',
        className: NO_SUB,
    },
    {
        id: 'rakuten_life',
        logo: '/assets/service-logos/life.png',
        name: '楽天生命',
        link: 'https://www.rakuten-life.co.jp/applicant/modifyAddressTel/',
        className: NO_SUB,
    },
    {
        id: 'rakuten_mobile_inner',
        logo: '/assets/service-logos/mobile_inner.png',
        name: '楽天モバイル(楽天回線)',
        subtitle: '楽天モバイル\n(楽天回線)',
        link: 'https://network.mobile.rakuten.co.jp/faq/detail/10000174/',
        className: WITH_SUB,
    },
    {
        id: 'rakuten_mobile_outer',
        logo: '/assets/service-logos/mobile_outer.png',
        name: '楽天モバイル(ドコモ回線／au回線)',
        subtitle: '楽天モバイル\n(ドコモ回線／au回線)',
        link: 'https://network.mobile.rakuten.co.jp/guide/users-information/?l-id=faq_redirect#rakutenmobile',
        className: WITH_SUB,
    },
    {
        id: 'rakuten_rakuma',
        logo: '/assets/service-logos/rakuma.png',
        name: '楽天ラクマ',
        link: 'https://fril.jp/settings',
        className: NO_SUB,
    },
];
